import { useEffect, useMemo, useState } from "react";
import { http } from "../lib/api";
import { CopyBtn } from "../components/CopyBtn";
import { Search } from "lucide-react";

export const Library = () => {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");

  useEffect(() => { http.get("/library").then((r) => setItems(r.data)); }, []);

  const cats = useMemo(() => ["all", ...Array.from(new Set(items.map((i) => i.category)))], [items]);

  const filtered = items.filter((i) =>
    (cat === "all" || i.category === cat) &&
    (!q || (i.title + i.goal + i.prompt).toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <div data-testid="library-page" className="mx-auto max-w-7xl px-6 py-16">
      <div className="mb-10">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-matrix)] mb-3">// module.library</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight">the curated shelf</h1>
        <p className="text-neutral-400 mt-4 max-w-2xl">Battle-tested prompts. Copy, paste, adapt.</p>
      </div>

      <div className="flex flex-wrap items-center gap-3 mb-6">
        <div className="relative flex-1 min-w-[240px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-500" />
          <input
            data-testid="library-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="search prompts..."
            className="w-full bg-black border border-white/10 focus:border-[color:var(--accent-amber)] outline-none pl-9 pr-3 py-2.5 text-sm"
            style={{ transitionProperty: "border-color", transitionDuration: "150ms" }}
          />
        </div>
        <div className="flex flex-wrap gap-1">
          {cats.map((c) => (
            <button
              key={c}
              data-testid={`library-cat-${c}`}
              onClick={() => setCat(c)}
              className={`px-3 py-1.5 text-[10px] uppercase tracking-widest border duration-150 ${
                cat === c
                  ? "border-[color:var(--accent-amber)] text-[color:var(--accent-amber)]"
                  : "border-white/10 text-neutral-400 hover:border-white/30"
              }`}
              style={{ transitionProperty: "color, border-color" }}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
        {filtered.map((p) => (
          <div key={p.id} data-testid={`library-card-${p.id}`} className="bg-[#0a0a0a] p-6 flex flex-col gap-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-amber)]">{p.category}</div>
            <h3 className="font-display font-bold text-lg">{p.title}</h3>
            <p className="text-sm text-neutral-400">{p.goal}</p>
            <pre className="bg-black border border-white/10 p-4 text-xs whitespace-pre-wrap text-neutral-200 mt-2">{p.prompt}</pre>
            <div className="mt-auto pt-2 flex justify-end">
              <CopyBtn text={p.prompt} testId={`library-copy-${p.id}`} label="copy prompt"
                analyticsEvent="library_prompt_copied"
                analyticsParams={{ prompt_id: p.id, category: p.category, title: p.title }} />
            </div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-full bg-[#0a0a0a] p-12 text-center text-neutral-500 text-sm">no matches. adjust the search.</div>
        )}
      </div>
    </div>
  );
};
